module.exports = ".header{\r\n    padding:20px;\r\n    font-size:20px;\r\n    color:#fff;\r\n}\r\n.header .logo{\r\n    width:150px;\r\n}\r\n.option:hover{\r\n    background: #f7c6c6;\r\n    color:#fff;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.css
// module id = ./src/app/common/header/header.component.css
// module chunks = main